import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { SubscriptionBadge } from './SubscriptionBadge';

const LogoMark = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <path d="M3 9h18M9 21V9"/>
  </svg>
);

export const SiteNav = ({ cta = 'estimate' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollTo = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className="lv2-nav" data-testid="site-nav">
      <div className="lv2-nav-inner">
        <button className="lv2-nav-logo" onClick={() => navigate('/')}>
          <div className="lv2-logo-mark"><LogoMark /></div>
          <div>
            <div className="lv2-wordmark">SCHEDULES OF WORK</div>
            <span className="lv2-nav-sub">RESIDENTIAL REFURB</span>
          </div>
        </button>
        <div className="lv2-nav-links">
          <button onClick={() => scrollTo('how')}>How it works</button>
          <button onClick={() => navigate('/pricing')} data-testid="nav-pricing">Pricing</button>
          <button onClick={() => scrollTo('sow')}>Schedule of Works</button>
          <button onClick={() => navigate('/contact')}>Contact</button>
          <button onClick={() => navigate('/account')} style={{ display: 'inline-flex', alignItems: 'center' }}>
            My Account<SubscriptionBadge compact />
          </button>
        </div>
        {cta === 'estimate' ? (
          <button className="lv2-nav-cta" onClick={() => navigate('/estimate')} data-testid="nav-get-estimate">
            Get estimate <ArrowRight className="w-3 h-3" />
          </button>
        ) : cta === 'home' ? (
          <button className="lv2-nav-cta" onClick={() => navigate('/')} data-testid="nav-back-home">
            Back to home <ArrowRight className="w-3 h-3" />
          </button>
        ) : null}
      </div>
    </nav>
  );
};
